module.exports = __webpack_public_path__ + "static/nxrt-mainpage7-3d86782eeeb753681c35096c843d0104.jpg";